import React, { useEffect, useState } from "react";
import { Button } from "antd";
import StoreList from "../components/stores/StoreList";
import { Store } from "../entities/interfaces/stores";
import StoreService from "../services/stores.service";
import ManageStore from "../components/stores/ManageStore";

const Stores = () => {
  const [stores, setStores] = useState<Store[]>([]);
  const [manageStoreModal, setManageStoreModal] = useState(false);
  const [selected, setSelected] = useState<Store | undefined>();

  useEffect(() => {
    getStores();
  }, []);

  const getStores = async () => {
    const res = await StoreService.list();
    if (!res?.success) return;
    setStores(res.data);
  };

  const openManageStoreModal = () => {
    setManageStoreModal(true);
  };

  const closeManageStoreModal = () => {
    if (selected) {
      setSelected(undefined);
    }
    setManageStoreModal(false);
  };

  return (
    <div>
      <div className="flex justify-between">
        <div className="mb-5">
          <h1 className="text-xl font-bold">Stores</h1>
          <p>Manage your organisation stores</p>
        </div>
        <Button type="primary" onClick={openManageStoreModal}>
          Create Store
        </Button>
        <ManageStore
          open={manageStoreModal}
          onChange={getStores}
          onClose={closeManageStoreModal}
          selected={selected}
        />
      </div>
      <StoreList
        stores={stores}
        onSelect={(data) => {
          openManageStoreModal();
          setSelected(data);
        }}
      />
    </div>
  );
};

export default Stores;
